import { Row } from 'components/shared/Layout';
import styled from 'styled-components';

import { colours } from 'themes/default';

export const StyledHeader = styled(Row)`
  background: rgba(6, 25, 62, 1);
  padding: 0 16px;
  margin-bottom: 0px;
  h1 {
    color: ${colours.Greyscale.White};
  }
`;

export const Heading = styled.h1`
  display: flex;
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  font-weight: 600;
  color: white;
  margin: 10px 0;
  font-size: 18px;
`;
